import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { CrudManager } from "@/components/admin/CrudManager";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/admin/categorias")({ component: Page });

const TABS = [
  { table: "proposal_categories", label: "Categorias de Propostas" },
  { table: "work_categories", label: "Categorias de Trabalhos" },
  { table: "news_categories", label: "Categorias de Notícias" },
] as const;

function Page() {
  const [active, setActive] = useState<string>(TABS[0].table);
  const current = TABS.find((t) => t.table === active) ?? TABS[0];

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap gap-2">
        {TABS.map((t) => (
          <Button
            key={t.table}
            size="sm"
            variant={t.table === active ? "default" : "outline"}
            onClick={() => setActive(t.table)}
          >
            {t.label}
          </Button>
        ))}
      </div>

      <CrudManager
        key={current.table}
        table={current.table}
        label={current.label}
        slugSource="name"
        fields={[
          { name: "name", label: "Nome", type: "text", required: true },
          { name: "slug", label: "Slug", type: "slug", required: true },
          { name: "icon", label: "Ícone (nome lucide)", type: "text" },
          { name: "sort_order", label: "Ordem", type: "number" },
        ]}
        columns={[
          { key: "name", label: "Nome" },
          { key: "slug", label: "Slug" },
          { key: "sort_order", label: "Ordem" },
        ]}
      />
    </div>
  );
}
